import React, { useState } from 'react';
const NPC = ({
  x,
  y,
  name,
  role,
  color,
  onInteract
}) => {
  const [isHovered, setIsHovered] = useState(false);
  return <div className="absolute cursor-pointer transition-transform" style={{
    left: x,
    top: y,
    transform: `translate(-50%, -50%) scale(${isHovered ? 1.1 : 1})`
  }} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} onClick={onInteract} data-id="element-137">
      {/* NPC circle */}
      <div className="w-10 h-10 rounded-full" style={{
      backgroundColor: color,
      boxShadow: `0 0 ${isHovered ? 30 : 20}px ${color}80`
    }} data-id="element-138" />
      {/* Name */}
      <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 text-white text-sm text-center whitespace-nowrap" data-id="element-139">
        {name}
      </div>
      {/* Role */}
      <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 text-gray-300 text-xs text-center whitespace-nowrap" data-id="element-140">
        {role}
      </div>
      {/* Hover text */}
      {isHovered && <div className="absolute top-8 left-1/2 transform -translate-x-1/2 text-yellow-400 text-xs whitespace-nowrap" data-id="element-141">
          Click to talk
        </div>}
    </div>;
};
export default NPC;